import { Component, OnInit } from '@angular/core';
import { ApiService } from 'app/services/api.service';
import { UnleashService } from 'shared/unleash/unleash.service';

import { environment } from '../../../../environments/environment';

@Component({
	selector: 'insights-page',
	templateUrl: './insights-page.component.html',
	styleUrls: ['./insights-page.component.scss'],
})
export class InsightsPageComponent implements OnInit {
	iframeUrl = '';
	isLoading = true;
	public isSupersetEnabled = false;
	dashboard = environment.superset.dashboards.performance.id;

	constructor(
		private readonly apiService: ApiService,
		private readonly unleash: UnleashService
	) {}

	ngOnInit(): void {
		this.isSupersetEnabled = this.unleash.isEnabled(
			'superset-performance-report'
		);
		const insightsv2Toggle = this.unleash.isEnabled('insightsv2');
		if (insightsv2Toggle && !this.isSupersetEnabled) {
			this.apiService
				.getEmbedUrlForLooker('586')
				.toPromise()
				.then((url) => {
					this.iframeUrl = url;
					this.isLoading = false;
				});
		}
	}
}
